import { Box, Theme } from "@mui/material";
import React, { useState, useEffect } from "react";
import { SideComponentChild, SideComponentWrapper } from "./styled";
import { useLocation, useNavigate } from "react-router-dom";

const menuItems = [
  { name: "DESCRIPTION." },
  { name: "PROCESS." },
  { name: "SOLUTIONS." },
  { name: "IMPACT." },
];

/**
 * Side navigation that highlights active section while scrolling.
 * Now hidden on Project 6 by excluding the "/project6" route.
 */
const SideComponent = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleScroll = (index: number) => {
    const section = document.getElementById("section" + index);
    const position = section?.offsetTop ?? 0;
    window.scrollTo({ top: position - 100 });
  };

  useEffect(() => {
    if (pathname === "/") {
      window.removeEventListener("scroll", setNavActive);
    } else {
      window.addEventListener("scroll", setNavActive);
    }
    return () => window.removeEventListener("scroll", setNavActive);
  }, [pathname]); //eslint-disable-line

  const setNavActive = () => {
    let currentMax = 0;
    for (let i = 1; i <= 4; i++) {
      const section = document.getElementById("section" + i);
      const position = section?.offsetTop ?? 0;
      if (position !== 0 && window.scrollY > position - 100) {
        currentMax = i;
      }
    }
    const nav = document.getElementById("nav" + currentMax);
    if (nav) {
      nav.classList.add("active");
      for (let i = 1; i <= 4; i++) {
        if (i !== currentMax) {
          const navSection = document.getElementById("nav" + i);
          navSection && navSection.classList.remove("active");
        }
      }
    }
  };

  // Hide on home, Project 5, and now Project 6
  const shouldRender = pathname !== "/" && pathname !== "/creativecoding" && pathname !== "/emotionalchat" && pathname !== "/play" && pathname !=="/owly" && pathname !=="/financial" && pathname !=="/ai-built";

  if (!shouldRender) return null;

  return (
    <SideComponentWrapper>
      <SideComponentChild showBorder>
        {menuItems.map((item, index) => (
          <Box
            key={index}
            id={"nav" + (index + 1)}
            sx={{
              background: "transparent",
              color: "text.primary",
              transition: "0s",
              "&:hover": {
                background: (theme: Theme) => theme.palette.primary.main,
                color: "#fff",
                cursor: "pointer",
              },
            }}
            onClick={() => handleScroll(index + 1)}
          >
            {item.name}
          </Box>
        ))}
      </SideComponentChild>
    </SideComponentWrapper>
  );
};

export default SideComponent;
